import { useTheme } from '../hooks/useTheme'
import MenuBar from '../components/MenuBar/MenuBar'
import { impressumData } from '../impressum/index'
import styles from './ImpressumPage.module.css'

/**
 * Standalone public page at /impressum (no auth required — German law mandates
 * that the Impressum be freely accessible).
 *
 * useTheme() is called here so that html[data-theme] is applied even when the
 * user navigates directly to /impressum without going through NewspaperLayout
 * (which normally hosts the MenuBar that calls useTheme).
 */
export default function ImpressumPage() {
  useTheme()

  const {
    publicationName,
    responsiblePerson,
    email,
    emailResponseNote,
    address,
    infoDate,
    sectionHeadings,
    presseLiabilityIntro,
    disclaimers,
  } = impressumData

  return (
    <div className={styles.pageWrapper}>
      <MenuBar lang="de" city="" />
      <main className={styles.main}>
      <div className="staticPage">
      <h1 className="staticPageTitle">Impressum</h1>

      {/* ── Section 1: Anbieterkennzeichnung ──────────────────────────── */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{sectionHeadings.anbieter}</h2>

        <p className={styles.paragraph}>
          <span className={styles.fieldLabel}>Name der Publikation:</span>
          <br />
          {publicationName}
        </p>

        <p className={styles.paragraph} style={{ marginTop: '16px' }}>
          <span className={styles.fieldLabel}>
            Verantwortlich im Sinne des Presserechts (gem. § 18 Abs. 2 MStV) &amp; Betreiber:
          </span>
          <br />
          {responsiblePerson}
        </p>

        <p className={styles.paragraph} style={{ marginTop: '16px' }}>
          <span className={styles.fieldLabel}>Kontakt</span>
          <br />
          <span className={styles.fieldLabel}>E-Mail:</span>{' '}
          <a className={styles.emailLink} href={`mailto:${email}`}>{email}</a>
          <span className={styles.emailNote}>({emailResponseNote})</span>
        </p>

        <p className={styles.paragraph} style={{ marginTop: '16px' }}>
          <span className={styles.fieldLabel}>Adresse (ladungsfähige Anschrift):</span>
          <br />
          {responsiblePerson}
          <address className={styles.addressBlock}>
            {address.map((line, i) => (
              <span key={i}>{line}{i < address.length - 1 && <br />}</span>
            ))}
          </address>
        </p>
      </section>

      {/* ── Section 2: Pressehaftung ───────────────────────────────────── */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{sectionHeadings.presse}</h2>

        <p className={styles.paragraph}>
          {presseLiabilityIntro}
        </p>

        <p className={styles.paragraph} style={{ marginTop: '12px' }}>
          <strong>{responsiblePerson}</strong>
          <br />
          <address className={styles.addressBlock}>
            {address.map((line, i) => (
              <span key={i}>{line}{i < address.length - 1 && <br />}</span>
            ))}
          </address>
        </p>
      </section>

      {/* ── Section 3: Disclaimer ──────────────────────────────────────── */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{sectionHeadings.disclaimer}</h2>

        {Object.values(disclaimers).map((entry) => (
          <div key={entry.heading} className={styles.subSection}>
            <h3 className={styles.subSectionTitle}>{entry.heading}</h3>
            <p className={styles.paragraph}>{entry.body}</p>
          </div>
        ))}
      </section>

      <p className={styles.infoDate}>Stand der Information: {infoDate}</p>
      </div>
      </main>
    </div>
  )
}
